const { computeProration } = require("./prorateCalculation");

module.exports = { computeProration };
